var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrDuplicat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4628 8.4396C35.3366 8.4396 35.3366 8.4396 35.4628 8.4396L29.1542 2.13105C29.1542 2.13105 29.0281 2.13105 29.0281 2.00488V8.4396H35.4628Z",
    fill: "#73007D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0166 10.332C27.5119 10.332 27.0072 9.95345 27.0072 9.32259V1.5H14.264C13.0023 1.5 11.9929 2.50937 11.9929 3.77108V6.29449H20.8249C21.9604 6.29449 22.9698 6.79918 23.7268 7.5562L29.9092 13.7386C30.6662 14.4956 31.1709 15.6311 31.1709 16.6405V32.8129H33.6943C34.956 32.8129 35.9654 31.8036 35.9654 30.5419V10.332H28.0166Z",
    fill: "#73007D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7753 15.1261L22.4667 8.81758C22.4667 8.81758 22.3406 8.81758 22.3406 8.69141V15.1261H28.7753Z",
    fill: "#73007D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4487 16.0101V8.1875H7.7054C6.44369 8.1875 5.43433 9.19687 5.43433 10.4586V37.2294C5.43433 38.4911 6.44369 39.5004 7.7054 39.5004H27.1357C28.3974 39.5004 29.4068 38.4911 29.4068 37.2294V17.0195H21.458C20.9533 17.0195 20.4487 16.6409 20.4487 16.0101Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrDuplicat);
export default __webpack_public_path__ + "static/media/dr_duplicat.792a1353f40d1d3f26016213ce17b921.svg";
export { ForwardRef as ReactComponent };